import { render } from "./InvoiceList.vue?vue&type=template&id=487b89d6&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=487b89d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487b89d6"]])

export default __exports__